import '../styles/SolutionsComponent.css';

const SolutionsComponent = ({solutionsContent}) => {
  if (!solutionsContent || !solutionsContent.solutions) {
    return null;
  }
  
  const { title, solutions } = solutionsContent;

  const mid = Math.ceil(solutions.length / 2);
  const leftColumn = solutions.slice(0, mid);
  const rightColumn = solutions.slice(mid);

  const renderSolution = (item, index, isRightColumn = false) => (
    <div className="col mb-4" key={index}>
      <div className="row align-items-center">
        <div className="col-auto">
          <img
            src={item.icon}
            alt={item.heading}
            className="img-fluid"
            style={{ maxWidth: '30px' }}
          />
        </div>
        <div className="col">
          <h3
            className="title"
            id="solutions-heading"
            style={{
              fontSize: 25,
              color: '#ffffffff',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
              fontWeight: '700'
            }}
          >
            {item.heading}
          </h3>
        </div>
      </div>
      <div className="row">
        <p
          className="text"
          id="solutions-text"
          style={{
            fontSize: 13,
            color: '#ffffffff',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
            textAlign: isRightColumn ? 'right' : 'left',
          }}
        >
          {item.description}
        </p>
      </div>
    </div>
  );

  return (
    <div className="container">
      <div className="row" id="solutions">
        <div className="col">
          <div className="row">
            <h2
              className="my-4 title"
              id="solutions-title"
              style={{
                color: '#ffffffff',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                fontWeight: '900'
              }}
            >
              {title}
            </h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              {leftColumn.map((item, idx) => renderSolution(item, idx, false))}
            </div>
            <div className="col-md-6">
              {rightColumn.map((item, idx) => renderSolution(item, idx, true))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionsComponent;